module.exports = __webpack_public_path__ + "media/reskin-images/icon--purple-plus-a83bdeca.svg";